import type { PropsWithChildren } from 'react';
import type { ProviderList } from './types';

type ComposeProvidersProps = PropsWithChildren<{
  providers: ProviderList;
}>;

export const ComposeProviders = ({ children, providers }: ComposeProvidersProps) => {
  return providers.reduceRight((previous, [Provider, props], key) => {
    return (
      <Provider key={key} {...props}>
        {previous}
      </Provider>
    );
  }, children) as React.ReactElement;
};
